
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sectors",
      function () {
        return require("private-next-pages/sectors/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sectors"])
      });
    }
  